var App = App || {};

App.ModalContent = (function ($) {
    'use strict';

    function init() {

        $('a').not(".InfoModalContinue").on('click', function (e) {
            var $this = $(this),
                url = $this.attr('href');
            var modalContent;
            if (url.indexOf("#") == 0) {
                modalContent = $(".modalcontent" + url);
            } else {
                $(".modalcontent").each(function (index, element) {
                    var urls = $(element).data("urls").split(",");
                    if (urls.indexOf(url) > -1) {
                        modalContent = $(this);
                        return;
                    }
                });
            }
            if (modalContent != undefined && modalContent.length > 0) {
                if (url.indexOf('#') !== 0) {
                    modalContent.find(".InfoModalContinue").attr('href', url).show();
                }
                else {
                    modalContent.find(".InfoModalContinue").hide();
                }
                modalContent.modal("show");
                e.preventDefault();
            }
        });

        $(".modalcontent .modal-footer a").on('click', function () {
            $(this).parents(".modalcontent").modal("hide");
        });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.ModalContent.init();
});